module.exports = __webpack_public_path__ + "static/media/omakotitalo.b4a13ca1.svg";